import React from 'react';
import { openNewTab } from 'src/common/config/FunctionHelper';
import { blogGeneration as blogGenerationText } from 'src/common/config/TextMessage';

const BlogGenerationHeader = () => {
  return (
    <React.Fragment>
      <div
        className="flex gap-2 cursor-pointer"
        onClick={() => {
          openNewTab(blogGenerationText.tutorialLink);
        }}
      >
        <img
          src={
            process.env.PUBLIC_URL +
            `/static/images/icons/keyword/book-open-02.svg`
          }
          alt="icon"
        />
        <p className="text-base font-bold text-left text-[var(--color-purple-deep-alt)] cursor-pointer">
          {blogGenerationText.tutorialText}
        </p>
      </div>
    </React.Fragment>
  );
};

export default BlogGenerationHeader;
